import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SellerPageContainer } from '@/components/seller/layout/SellerPageContainer';
import { sellerService } from '@/services/seller';
import { useSellerStore } from '@/store/seller';
import { StoreDetailPage } from '@/pages/store/StoreDetailPage';

export function StoreMonitoringPage() {
  const navigate = useNavigate();
  const { setLoading, setError } = useSellerStore();
  
  const [restaurantId, setRestaurantId] = useState<string>('');

  useEffect(() => {
    loadRestaurantId();
  }, []);

  const loadRestaurantId = async () => {
    try {
      setLoading(true);
      
      const restaurantResult = await sellerService.getSellerRestaurantId();
      if (!restaurantResult.success || !restaurantResult.restaurantId) {
        setError(restaurantResult.error || '레스토랑 정보를 찾을 수 없습니다');
        return;
      }

      setRestaurantId(restaurantResult.restaurantId);
      
    } catch (error) {
      console.error('Restaurant ID load error:', error);
      setError('레스토랑 정보를 불러오는 중 오류가 발생했습니다');
    } finally {
      setLoading(false);
    }
  };

  if (!restaurantId) {
    return (
      <SellerPageContainer activeNavId="store">
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500 mx-auto mb-4"></div>
            <p className="text-gray-600">레스토랑 정보를 불러오는 중...</p>
          </div>
        </div>
      </SellerPageContainer>
    );
  }

  return (
    <SellerPageContainer activeNavId="store">
      <div className="pb-4">
        {/* 헤더 */}
        <div className="mb-6 flex items-center">
          <button
            onClick={() => navigate(-1)}
            className="p-2 text-gray-600 hover:text-gray-800 mr-4"
          >
            ←
          </button>
          <h1 className="text-[24px] font-bold text-gray-800 flex-1 text-center mr-12">내 가게 모니터링</h1>
        </div>

        {/* 모니터링 안내 */}
        <div className="mb-4 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 className="text-base font-semibold text-blue-800">소비자 관점에서 내 가게 확인</h3>
          </div>
          <p className="text-sm text-blue-700">
            고객이 실제로 보는 내 가게 정보를 확인할 수 있습니다. 각 주문 유형별 상품 정보와 가격을 점검해보세요.
          </p>
        </div>

        {/* 모니터링 뷰 - 실제 고객용 StoreDetailPage를 readonly로 표시 */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <StoreDetailPage storeId={restaurantId} readonly={true} />
        </div>
      </div>
    </SellerPageContainer>
  );
}